import MyInput from "../../App/MyInput/MyInput";
import {Regex} from "../../App/Regex";
import React from "react";

export const FormConnection = ({ refSubmit, refForm, handleSubmit, alerts, setAlert }) => {

    return <form className={"row"} onSubmit={async (e) => {

        e.preventDefault()
        handleSubmit(e)
    }}>
        <MyInput
            refForm={refForm}
            label="Adresse mail"
            placeholder="adresse@mail.com"
            autocomplete="email"
            className={"col-12"}
            id="mail"
            name={"mail"}
            type={"text"}
            required={true}
            regex={Regex.mail}
        />
        <MyInput
            refForm={refForm}
            label={"Mot de passe"}
            type={"password"}
            name={"password"}
            className={"col-12"}
            id={"password"}
            placeholder={"••••••••••••"}
            autoComplete={"current-password"}
            required={true}/>
        {alerts}
        <button className="btn btn-primary disabled" disabled={true} type="submit" id={"ConnectionAccount"}
                ref={refSubmit}>Me connecter
        </button>
    </form>
}